module.exports = __webpack_public_path__ + "media/public/images/icon-favorite-normal-fb02479d264a8892cdfb7857b21717c6.svg";